import { initSubRoutes } from '../../../../../utils/router';

const RoutesCreerTitreDetention = initSubRoutes({
    route: '/creer/:type',
    subroutes: {},
    nom: 'Créer un titre de détention',
});

export default RoutesCreerTitreDetention;
